<template lang="pug">
v-stepper.elevation-25(v-model='e1')
    v-stepper-header.elevation-25
        v-stepper-step(:complete='e1 > 1' step='1')
            | Step 1: Asset Folder
        v-divider
        v-stepper-step(:complete='e1 > 2' step='2')
            | Step 1: Branding
        v-divider
        v-stepper-step(step='3')
            | Step 1: Theme
    v-stepper-items
        v-stepper-content(step='1' v-if="tenantId && tenantId != ''")
            v-card(flat)
                v-card-text.my-12.text-center
                    | Create a new folder named
                    code.mx-2 {{tenantId}}
                    | in this folder: 
                    v-btn(link small text target="_blank" v-bind:href="''+bucket+'?region=eu-central-1&prefix=protected/'+tenantId+'/object/create_folder?region=eu-central-1&prefix=protected'") protected
                    | and enable encryption
                v-card-actions
                    
                    v-spacer 
                    v-btn(depressed @click='e1 = 2') Continue
        v-stepper-content(step='2')
            v-card(flat)
                v-card-text.my-12.text-center
                    h2 Upload the logo
                    v-btn(link small text target="_blank" v-bind:href="''+bucket+'?region=eu-central-1&prefix=protected/'+tenantId+'/&showversions=false'") here
                    v-form.mt-6(@submit.prevent="submitBranding")
                        v-text-field(rounded filled v-model="branding.logo" label="Set logo filename" placeholder="logo_simplymotion.png")
                        v-text-field(rounded filled v-model="branding.primaryColor" label="Set primary color" placeholder="#505050")
                        v-text-field(rounded filled v-model="branding.accentColor" label="Set accent color" placeholder="#1bf231")
                        v-btn.text-center(color="accent" depressed type="submit") Save branding

                v-card-actions
                    v-btn(text='' @click='e1 = 1') Back
                    v-spacer 
                    v-btn(depressed @click='e1 = 3') Continue
        v-stepper-content(step='3')
            v-card(flat)
                v-card-text.my-12.text-center
                    v-form.mt-6(@submit.prevent="submitTheme")
                        v-text-field(rounded filled v-model="theme.title" label="Set theme name" placeholder="Default Theme")
                        v-text-field(rounded filled v-model="theme.primaryColor" label="Set primary color" placeholder="#505050")
                        v-text-field(rounded filled v-model="theme.accentColor" label="Set accent color" placeholder="#1bf231")
                        v-text-field(rounded filled v-model="theme.textColor" label="Set text color" placeholder="#ffffff")
                        v-btn.mb-8.text-center(color="accent" depressed type="submit") Save theme
                    | Create folder 
                    code themes
                    |  and a new folder with name
                    code.mx-2 {{themeId}}
                    | inside 
                    v-btn(link small text target="_blank" v-bind:href="''+bucket+'/object/create_folder?region=eu-central-1&prefix=protected/'+tenantId+'/'") here
                    | and enable encryption.
                    | Now clone 
                    v-btn(link small text target="_blank" 
                        v-bind:href="''+bucket+'?prefix=protected/blueprint/themes/default/&showversions=false'") theses
                    | files into the new folder.
                v-card-actions
                    v-btn(text='' @click='e1 = 2') Back
                    v-spacer
                    v-btn(depressed @click='e1 = 1') Finish

</template>

<script>
import awsmobile from "@/aws-exports.js";
export default {
  components: {},
  props: ["tenantId"],
  data() {
    return {
      e1: 1,
      bucket:
        "https://s3.console.aws.amazon.com/s3/buckets/" +
        awsmobile.aws_user_files_s3_bucket,
      branding: {
        primaryColor: "",
        accentColor: "",
        logo: "",
      },
      theme: {
        primaryColor: "",
        accentColor: "",
        textColor: "#ffffff",
        title: "",
      },
      themeId: "",
    };
  },
  methods: {
    submitBranding() {
      this.$store
        .dispatch("superAdmin/CREATE_BRANDING", {
          ...this.branding,
          tenantId: this.tenantId,
        })
        .then(() => {
          this.e1 = 3;
        });
    },
    async submitTheme() {
      const response = await this.$store.dispatch("superAdmin/CREATE_THEME", {
        ...this.theme,
        tenantId: this.tenantId,
      });
      if (response) {
        this.themeId = response.data.createTheme.id;
      }
    },
  },
};
</script>

<style lang="sass" scoped>
@import '@/assets/style/main'
</style>
